import { Box } from '@mui/material';
import { PRINT_CUT_GUIDE_BORDER } from './printStyles';

interface CutGuideProps {
  height: string;
  showLine: boolean;
}

const CutGuide = ({ height, showLine }: CutGuideProps) => (
  <Box
    aria-hidden
    sx={{ flex: `0 0 ${height}`, display: 'flex', alignItems: 'center' }}
  >
    {showLine ? (
      <Box sx={{ width: '100%', borderTop: PRINT_CUT_GUIDE_BORDER }} />
    ) : null}
  </Box>
);

export default CutGuide;
